export class HookHmac {
  secret: string;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}
